<template>
  <div>
    <IndicatorScore
      :disabled="disabled"
      :link-back="linkBack"
      :show-un-submit="showPosQuestions"
      :is-submitted="submittion.preIsSubmitted && submittion.postIsSubmitted"
      :is-completed="submittion.preIsSubmitted || submittion.postIsSubmitted"
      @onSubmit="onSubmit"
      @onUnSubmit="onUnSubmit"
    />
    <div v-for="(section, index) in submittion.sections" :key="index">
      <ValidationObserver :ref="`formValidator-${index}`" novalidate tag="form">
        <InterventionQuestion
          :question-id="index"
          :config="section"
          :evidences="evidences"
          :pre-is-submitted="submittion.preIsSubmitted"
          :post-is-submitted="submittion.postIsSubmitted"
          :show-pos-questions="showPosQuestions"
        />
      </ValidationObserver>
    </div>

    <customModal
      v-if="modalMessage"
      :message-box="{
        title: 'Terminos y Responsabilidades',
        message: modalMessage,
        type: 'confirm',
        icon: 'fa fa-exclamation',
      }"
      :checkbox="{
        label: 'Acepto los términos y responsabilidades',
        Show: true,
        isRequired: true,
        validationMessage: modalErrorMessage,
      }"
      :success-callback="onSubmitModal"
      :cancel-callback="onCloseModal"
    />
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import customModal from '@/components/common/modal/custommodal';
import IndicatorScore from './components/Score';
import InterventionQuestion from './components/InterventionQuestion';
// import QuestionTypes from "@/utils/constants/questionnairetypes.js";
import resourcesService from '@/services/resources.js';
import mixAlert from '@/mixin/alert.mixin';
import mixWait from '@/mixin/loading.mixin';
import store from '@/store/index';
import JQuery from 'jquery';
import peiStatuses from '@/utils/constants/pei/peiStatus';
let $ = JQuery;

const API_QUESTIONARY_SUBMIT = 'api/questionnaire/submit';
const API_QUESTIONARY_SUBMITPRE = 'api/questionnaire/submitPre';
const API_QUESTIONARY_ANSWERED_BY_STUDENT =
  'api/questionnaire/answeredbystudent';
const API_QUESTIONARY_EVIDENCES = 'api/questionnaire/evidences';

export default {
  mixins: [mixAlert, mixWait],
  components: {
    IndicatorScore,
    InterventionQuestion,
    ValidationObserver,
    customModal,
  },
  created() {
    this.loadData();
  },
  data() {
    return {
      nombre: '',
      submittion: {},
      sections: [],
      evidences: [],
      validationMessages: {},
      modalMessage: '',
      modalErrorMessage: '',
      disabled: false,
      fromRote: '',
      routes: [],
      questionnaireTypes: [],
      showPosQuestions: false,
      isPeiCompleted: store.getters.SelectedPeiStatus == peiStatuses.Completado,
      linkBack: '',
    };
  },
  methods: {
    loadData() {
      this.loadDataFromRoute();
      this.loadValidationMessages();
      this.getQuestionary();
    },
    loadDataFromRoute() {
      const paramsFromRoute = this.$root.$route.params;
      if (paramsFromRoute && paramsFromRoute.from) {
        this.fromRote = paramsFromRoute.from;
        this.routes = paramsFromRoute.place;
        this.questionnaireTypes = paramsFromRoute.questionnaireTypes;
        this.showPosQuestions = this.fromRote === 'Pei' ? true : false;

        if (paramsFromRoute.linkBack) this.linkBack = paramsFromRoute.linkBack;
      }
    },
    getQuestionary: function() {
      // let self = this;
      const path =
        API_QUESTIONARY_ANSWERED_BY_STUDENT +
        `/${store.getters.SelectedStudent.studentId}` +
        `/${store.getters.SelectedPei}` +
        `?questionnaireTypes=${this.questionnaireTypes}`;
      this.$ApiGet(path)
        .then((response) => {
          this.submittion = response.data;
          this.submittion.peiId = store.getters.SelectedPei;

          if (this.showPosQuestions) {
            this.disabled = !this.isPeiCompleted;
          } else {
            this.disabled = this.submittion.preIsSubmitted;
          }
        })
        .catch(() => {
          this.ShowToast(
            'Alerta',
            this.validationMessages['R03200108'],
            'error'
          );
        });

      this.$ApiGet(API_QUESTIONARY_EVIDENCES, {
        validForRegistry: false,
        validForRegistryEligibility: false,
        validForTabII: false,
        validForTabVIII: false,
      }).then((response) => (this.evidences = response.data));
    },
    async loadValidationMessages() {
      this.validationMessages = await resourcesService.LoadValidationMessages([
        'R03200108',
        '0229',
        '0397',
        '0546',
        '0636',
      ]);

      this.modalMessage = this.validationMessages['0546'];
      this.modalErrorMessage = this.validationMessages['0229'];
    },
    areQuestionsSubmitted() {
      if (this.showPosQuestions) {
        return this.submittion.postIsSubmitted;
      } else {
        return this.submittion.preIsSubmitted;
      }
    },
    async isInvalid() {
      const isFormValid = await this.areAllSectionsValid();
      return !isFormValid || this.validateWrongNumberInIds();
    },
    validateWrongNumberInIds() {
      return this.submittion.sections.some((sec) => {
        let isInvalidPre = sec.preQuestions.some(
          (pre) =>
            this.isNotANumber(pre.evidenceSourceId) ||
            this.isNotANumber(pre.questionnaireAnswerId)
        );

        let isInvalidPost =
          this.showPosQuestions &&
          sec.postQuestions.some((post) => {
            return (
              this.isNotANumber(post.answerNumericValue) ||
              this.isNotANumber(post.questionnaireAnswerId)
            );
          });

        return isInvalidPre || isInvalidPost;
      });
    },
    isNotANumber(_number) {
      return _number === null || isNaN(_number) || _number <= 0;
    },
    async areAllSectionsValid() {
      let isValid = true;
      //JSF US94464 - trigger the validation for all sections.
      for (let index = 0; index < this.submittion.sections.length; index++) {
        const form = this.$refs[`formValidator-${index}`][0];
        if (isValid) isValid = await form.validate();
      }

      return isValid;
    },
    onCloseModal() {},
    async onSubmit() {
      if (this.disabled) return;
      if (await this.isInvalid())
        this.ShowToast('Alerta', this.validationMessages['0397'], 'error');
      else $('#popup').modal('show');
    },
    async onSave() {
      if (this.disabled) return;
      this.sendRequest(false);
    },
    onSubmitModal(isChecked) {
      if (!isChecked) {
        this.ShowToast('Alerta', this.validationMessages['0229'], 'error');
        return;
      }
      this.sendRequest(true);
    },
    sendRequest(isSubmittion) {
      if (isSubmittion) {
        this.toggleControls(true);
        this.submit();
      }
    },
    submit() {
      this.submittion.isSubmitted = true;
      let url = this.showPosQuestions
        ? API_QUESTIONARY_SUBMIT
        : API_QUESTIONARY_SUBMITPRE;
      this.$ApiPost(url, this.submittion)
        .then(() => {
          this.loadData();
          this.ShowToast(
            'Información',
            this.validationMessages['0636'],
            'success'
          );
        })
        .catch(() => {
          this.toggleControls(false);
          this.ShowToast(
            'Alerta',
            this.validationMessages['R03200108'],
            'error'
          );
        });
    },
    toggleControls(value) {
      this.disabled = value;
      if (this.showPosQuestions) {
        this.submittion.preIsSubmitted = this.submittion.postIsSubmitted = value;
      } else {
        this.submittion.preIsSubmitted = value;
      }
    },
    onUnSubmit() {
      this.$ApiPost('api/questionnaire/' + this.submittion.peiId + '/unSubmit')
        .then(() => {
          this.getQuestionary();
          this.disabled = false;
          this.ShowToast('', this.getMessage('0636').name, 'success');
        })
        .catch((err) => {
          this.response = err;
        });
    },
  },
};
</script>
